/**
 * スタートガイドのTodoリストで使用する要素ID。
 * id属性とセレクタ（#id）で同じ値を使うため、ここで一元定義する。
 */
export const START_GUIDE_HOTEL_INFO_ID = "start-guide-hotel-info";
export const START_GUIDE_HOTEL_POLICY_ID = "start-guide-hotel-policy";
